export default __webpack_public_path__ + "static/icon-0a62fef2addd6e60a05db5c964002a2d.png";